import { MessageCircle } from "lucide-react";
import { buildWhatsappUrl } from "@/lib/whatsapp";
import { useLanguage } from "@/contexts/LanguageContext";

const FloatingWhatsApp = () => {
  const { language } = useLanguage();
  const label = language === "nl" ? "Stuur ons een WhatsApp" : "Send us a WhatsApp";
  const message =
    language === "nl"
      ? "Hoi PlayfieldVR! Ik heb een vraag."
      : "Hi PlayfieldVR! I have a question.";

  return (
    <a
      href={buildWhatsappUrl(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="fixed bottom-4 left-4 md:bottom-6 md:left-6 z-50 group flex items-center gap-2 bg-[#25D366] text-white font-semibold rounded-full shadow-lg shadow-[#25D366]/40 hover:bg-[#20b858] hover:scale-105 transition-all duration-300 pl-3 pr-4 py-3"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline text-sm">{label}</span>
    </a>
  );
};

export default FloatingWhatsApp;
